<template>
  <main>
    <b-container>
      <div class="page-breadcrumb">
        <router-link :to="{ name: 'ProjectIndex' }" class="border-0"
          >
          <i class="fa fa-angle-left" /> Back to projects</router-link
        >
      </div>

      <div class="section-header">
        <div>
          <h1 class="heading">Create project</h1>
        </div>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <ProjectForm :form="form" @callback="submit"></ProjectForm>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import { setTimeout } from "timers";
import { mapState, mapActions } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import ProjectForm from "./ProjectForm";

export default {
  name: "ProjectCreate",
  components: {
    ProjectForm
  },
  extends: InitAdmin,
  data() {
    return {
      adminUser: null,
      form: {
        name: null,
        description: null,
        tag: [],
        admin: null
      },
      retrylimit: 3
    };
  },
  computed: {
    ...mapState({
      users: (state) => state.user.users,
      serverResponseCode: (state) => state.admin.serverResponseCode
    })
  },
  mounted() {
    this.loadUsers();
    this.adminUser = _.find(
      this.users,
      (user) => user.user_name === "admin"
    );
  },
  methods: {
    ...mapActions(["saveProject", "deleteProject", "loadProjects", "loadUsers"]),
    submit() {
      const data = {
        name: this.form.name,
        description: this.form.description,
        tag: this.form.tag.toString(),
        admin: this.adminUser? this.adminUser._id:""
      };
      this.saveProject({
        project: data
      }).then(res => {
        if(this.serverResponseCode !== 403){
        this.$toasted.show("Project created successfully", {type: "success"});
        setTimeout(() => {
          this.$router.push({ name: "ProjectView", params: { id: res._id } });
        }, 1000);
        /*this.loadProjects().then((projs) => {
          if(projs.filter(p => p._id === res._id).length > 0){
            this.$toasted.show("Project created successfully", {type: "success"});
            setTimeout(() => {
              this.$router.push({ name: "ProjectView", params: { id: res._id } });
            }, 1000);
          }
          else{
            this.retrylimit -= 1;
            this.deleteProject({ projectId: res._id }).then(() => {
              setTimeout(() => {
                if(this.retrylimit > 0){
                  this.submit();
                }
                else{
                  this.$toasted.show("Unable to create your project this time, please try later!", {
                    type: "error"
                  });
                }
              }, 1000);
            });
          }
        })*/
        }
      });
    }
  }
};
</script>
